import { render, staticRenderFns } from "./DetailHeadBase.vue?vue&type=template&id=42b08fb0&scoped=true"
import script from "./DetailHeadBase.vue?vue&type=script&lang=js"
export * from "./DetailHeadBase.vue?vue&type=script&lang=js"
import style0 from "./DetailHeadBase.vue?vue&type=style&index=0&id=42b08fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b08fb0",
  null
  
)

export default component.exports